import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiStar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_19213_481593)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M7.05964 15C7.05964 14.1264 6.89791 13.3055 6.57441 12.5373C6.26105 11.769 5.8314 11.1007 5.28552 10.5323C4.73963 9.96402 4.09771 9.51672 3.35976 9.19047C2.62181 8.85367 1.83331 8.6853 0.994263 8.6853C1.83331 8.6853 2.62181 8.52215 3.35976 8.19591C4.09771 7.85911 4.73963 7.40657 5.28552 6.83825C5.8314 6.26992 6.26105 5.60162 6.57441 4.83333C6.89791 4.06504 7.05964 3.24413 7.05964 2.3706C7.05964 3.24413 7.21634 4.06504 7.52971 4.83333C7.85321 5.60162 8.28788 6.26992 8.83376 6.83825C9.37965 7.40657 10.0216 7.85911 10.7595 8.19591C11.4975 8.52215 12.286 8.6853 13.125 8.6853C12.286 8.6853 11.4975 8.85367 10.7595 9.19047C10.0216 9.51672 9.37965 9.96402 8.83376 10.5323C8.28788 11.1007 7.85321 11.769 7.52971 12.5373C7.21634 13.3055 7.05964 14.1264 7.05964 15Z",
				fill: "url(#paint0_radial_19213_481593)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip1_19213_481593)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M2.46095 5.12422C2.46095 4.76979 2.39533 4.43672 2.26408 4.125C2.13693 3.81328 1.96261 3.54212 1.74112 3.31153C1.51964 3.08094 1.25919 2.89945 0.959772 2.76708C0.660356 2.63043 0.340432 2.56211 0 2.56211C0.340432 2.56211 0.660356 2.49592 0.959772 2.36355C1.25919 2.2269 1.51964 2.04328 1.74112 1.81269C1.96261 1.5821 2.13693 1.31095 2.26408 0.999223C2.39533 0.6875 2.46095 0.354426 2.46095 0C2.46095 0.354426 2.52453 0.6875 2.65168 0.999223C2.78293 1.31095 2.9593 1.5821 3.18078 1.81269C3.40227 2.04328 3.66272 2.2269 3.96213 2.36355C4.26154 2.49592 4.58147 2.56211 4.92191 2.56211C4.58147 2.56211 4.26154 2.63043 3.96213 2.76708C3.66272 2.89945 3.40227 3.08094 3.18078 3.31153C2.9593 3.54212 2.78293 3.81328 2.65168 4.125C2.52453 4.43672 2.46095 4.76979 2.46095 5.12422Z",
				fill: "url(#paint1_radial_19213_481593)"
			})
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint0_radial_19213_481593",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "matrix(12.2313 4.30608 -33.1325 102.008 2.19814 7.50332)",
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .0671246,
						stopColor: "#9168C0"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .342551,
						stopColor: "#5684D1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .672076,
						stopColor: "#1E3FC0"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_19213_481593",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "matrix(4.96269 1.74714 -13.4431 41.3884 0.488457 2.08254)",
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .0671246,
						stopColor: "#9168C0"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .342551,
						stopColor: "#5684D1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .672076,
						stopColor: "#1BA1E3"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_19213_481593",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 12.1308,
					height: 12.6294,
					fill: "white",
					transform: "translate(0.994263 2.3706)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_19213_481593",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 4.92191,
					height: 5.12422,
					fill: "white"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgAiStar);
export { ForwardRef as ReactComponent };
